module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/modal-window/message-with-text-popup/message-with-text-popup.component.sass
// module id = ./src/app/modules/modal-window/message-with-text-popup/message-with-text-popup.component.sass
// module chunks = main